import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { MainMenu } from "./MainMenu/MainMenu";
import { GrandChildMenus } from "./GrandChildMenus/GrandChildMenus";
import { ChildMenus } from "./ChildMenus/ChildMenus";
import { WebAppFooter } from "./WebAppFooter/WebAppFooter";
import { WebAppFooterTabs } from "./WebAppFooter/WebAppFootertabs";
export const MainNavigation = () => {
  const navigate = useNavigate();
  const query = useQuery();

  useEffect(() => {
    if(query.get('id')){
      return;
    }
    const activeTab = query.get("activeTab");
    if (!activeTab) {
      navigate(`/dedicated/corporate/navigation?activeTab=webAppFooter&subActiveTab=aboutAndLegal`, {
        replace: true,
      });
    } else if (activeTab === 'webAppFooter' && !query.get('subActiveTab')) {
      navigate(`/dedicated/corporate/navigation?activeTab=webAppFooter&subActiveTab=aboutAndLegal`, {
        replace: true,
      });
    }
  }, [query.get("activeTab"), query.get("subActiveTab")]);
  const items = [
    {
      label: "Web App Footer",
      key: "webAppFooter",
      children: <WebAppFooterTabs />,
    },
    {
      label: "Main Menu",
      key: "mainMenu",
      children: <MainMenu />,
    },
    {
      label: "Child Menu",
      key: "childMenus",
      children: <ChildMenus />,
    },
    {
      label: "Grand Child Menu",
      key: "grandChildMenus",
      children: <GrandChildMenus />,
    },
  ];

 const handleProductManagement = (activeTab: string, subActiveTab: string, thirdChildActiveTab: string) => {
  if (activeTab === "mainMenu") {
    return (
      <Button
        onClick={() => {
          navigate("/dedicated/corporate/navigation/mainMenu/add");
        }}
        icon={<Icon icon="lucide:plus" />}
      >
        Add Main Menu
      </Button>
    );
  } else if (activeTab === "childMenus") {
    return (
      <Button
        onClick={() => {
          navigate("/dedicated/corporate/navigation/childMenus/add");
        }}
        icon={<Icon icon="lucide:plus" />}
      >
        Add Child Menu
      </Button>
    );
  } else if (activeTab === "grandChildMenus") {
    return (
      <Button
        onClick={() => {
          navigate("/dedicated/corporate/navigation/grandChildMenus/add");
        }}
        icon={<Icon icon="lucide:plus" />}
      >
        Add Grandchild Menu
      </Button>
    );
  } else if (thirdChildActiveTab === "servicePortals") {
    return (
      <Button
        onClick={() => {
          navigate("/dedicated/corporate/navigation/webAppFooter/servicePortals/add");
        }}
        icon={<Icon icon="lucide:plus" />}
      >
        Add Service Portal
      </Button>
    );
  } else if (thirdChildActiveTab === "socialMedia") {
    return (
      <Button
        onClick={() => {
          navigate("/dedicated/corporate/navigation/webAppFooter/socialMedia/add");
        }}
        icon={<Icon icon="lucide:plus" />}
      >
        Add Social Media
      </Button>
    );
  }
};


  return (
    <ContentWrapper
      title={"Navigation"}
      actionItems={handleProductManagement(query.get("activeTab"), query.get('subActiveTab'), query.get('thirdChildActiveTab'))}
    >
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${activeKey}`);
        }}
      ></Tabs>
    </ContentWrapper>
  );
};
